/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-05 15:20:23
 * @LastEditTime: 2022-01-06 10:58:00
 * @LastEditors: zhao - 🍉
 * @Description: 资金清算记录 - 编辑
 * @FilePath: /zhzj-admin/src/page/TransferRecordLog/update.jsx
 */
import React, { useState } from 'react'
import { InputNumber, message, Modal, Select } from 'antd'
import ModalScrollContainer from '../../components/ModalScrollContainer';
import DetailTitle from '../../components/DetailTitle';
import { CustomCol, CustomRow } from '../../components/Custom';
import TransferRecordLogInfo from './components/RecordLogInfoView';
import { fetchTransferRecordLogAdd, fetchTransferRecordLogGet, fetchTransferRecordLogUpdate } from '../../services/transferRecordLog';

const TransferRecordUpdate = (props) => {
    const [visible, setVisible] = useState(false);
    const [id, setId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [detailData, setDetailData] = useState({});
 
    const open = (_id) => {
        setVisible(true)
        setId(_id || null)
        if (_id) {
            postTransRecordGet({transferRecordLogId: _id})
        } else {
            setDetailData({})
        }
        return new Promise((resolve, reject) => {
            this.monitor = { resolve, reject }
        })
    }
    const close = () => {
        setVisible(false)
    }
    const mapTransferRecordType = [
        { title: '云贷费用', value: 1 },
        { title: '业主租金', value: 2 },
        { title: '平台运营费用', value: 3 },
        { title: '商户结余退款', value: 4 },
        { title: '其他费用', value: 5 },
    ]
    const mapInstructionType = [
        { title: '银联分账', value: 1 },
        { title: '银联划付', value: 2 },
    ]

    const postTransRecordGet = (data) => {
        setLoading(true)
        fetchTransferRecordLogGet(data).then(res => {
            res.totalAmount /= 100
            res.infoList = (res.infoList || []).map(e => {
                e.transferAmount /= 100
                return e
            })
            setDetailData(res || {})
        }).finally(() => {
            setLoading(false)
        })
    }

    const postSubmit = (data) => {
        const post = id ? fetchTransferRecordLogUpdate : fetchTransferRecordLogAdd
        data.id = id || undefined
        setLoading(true)
        return post(data).then(res => {
            message.success('保存成功')
        }).finally(() => {
            setLoading(false)
        })
    }
    const handleFormChange = (data) => {
        setDetailData({...detailData, ...data })
    }

  
    const handleLogInfoChange = (e) => {
        handleFormChange({ infoList: e })
    }

    const handleSubmit = () => {
        if (!detailData.transferRecordType) return message.warning('请选择划账类型')
        if (!detailData.totalAmount) return message.warning('请输入总金额')
        if (!detailData.instructionType) return message.warning('请选择指令类型')

        for (let i = 0; i< detailData.infoList.length; i++) {
            const current = detailData.infoList[i]
            console.log('111', Object.values(current))
            
            // 银联商户号和金额必填
            if (!current.merchantNo || !current.transferAmount) {
                return  message.warning('请完成明细数据表格')
            }
            // 如果 detailData.instructionType === 1 (银联分账) 则表格数据全必填
            if (detailData.instructionType === 1) {
                if (
                    !current.accountName || 
                    !current.accountNumber || 
                    !current.bankName || 
                    !current.bankNo
                ) {
                    return  message.warning('请完成明细数据表格')
                }
            }
        }
        
        postSubmit(detailData).then(() => {
            close()
            this.monitor.resolve()
        })
    }

    props.getRef && props.getRef({ open })
    return (
        <Modal title="银联划账管理" width={900} visible={visible} onOk={handleSubmit} confirmLoading={loading} onCancel={close}>
             <ModalScrollContainer loading={loading} style={{ paddingTop: 0 }}>
                <div className="custom" >
                    <DetailTitle title="基础信息" />
                    <CustomRow >
                        <CustomCol label="划账类型" colStyle={{width: 750}}>
                            <Select 
                                style={{width: '100%'}}
                                value={detailData.transferRecordType}
                                onChange={(e) => handleFormChange({transferRecordType: e})} 
                            >
                                {mapTransferRecordType.map(e => <Select.Option key={e.value} value={e.value}>{e.title}</Select.Option>)}
                            </Select>
                        </CustomCol>
                    </CustomRow>
              
                    <CustomRow divider>
                        <CustomCol label="总金额" colStyle={{width: 750}}>
                            <InputNumber value={detailData.totalAmount} onChange={(e) => handleFormChange({totalAmount: e})}  />
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="指令类型" colStyle={{width: 750}}>
                            <Select 
                                style={{width: '100%'}} 
                                value={detailData.instructionType}
                                onChange={(e) => handleFormChange({instructionType: e})} 
                            >
                                {mapInstructionType.map(e => <Select.Option key={e.value} value={e.value}>{e.title}</Select.Option>)}
                            </Select>
                        </CustomCol>
                    </CustomRow>
                    <DetailTitle title="明细数据" />
                    <TransferRecordLogInfo 
                        value={detailData.infoList || []} 
                        onChange={handleLogInfoChange} 
                        instructionType={detailData.instructionType}
                    />
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}

export default TransferRecordUpdate




// WEBPACK FOOTER //
// ./src/page/TransferRecordLog/update.jsx